<div *ngIf="quote?.data" [ngSwitch]="productClass">
  <app-refer-ahm *ngSwitchCase="'ahm-car'" [quote]="quote"></app-refer-ahm>
  <app-refer-generic-car *ngSwitchCase="'car'" [quote]="quote"></app-refer-generic-car>
  <app-refer-generic-travel *ngSwitchCase="'travel'" [quote]="quote"></app-refer-generic-travel>
</div>